<template>
<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-7 col-md-12">
        <h4 class="card-title"><i class="ti-camera"></i> Foto</h4></div>
      <div class="col-lg-5 col-md-12 text-right">
        <a
          class="btn btn-fill btn-primary btn-sm btn"
          v-if="hasImage && showEditButton"
          @click="editImage()"
        ><i class="ti-pencil"></i> Editar</a>
      </div>
    </div>
  </div>
  <div class="card-content text-center">
    <img
      :class="customerImageClass"
      :src="customerImage"
    >
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CustomerImageCard',
  props: {
    customer: {
      required: true,
      type: Object
    },
    showEditButton: {
      default: true,
      type: Boolean
    },
    timestampImage: {
      default: new Date().getTime()
    },
    hasImage: {
      default: false
    }
  },
  computed: {
    ...mapGetters('customers', {
      urlImgs: 'urlImgs'
    }),
    customerImage: function () {
      return this.hasImage ? this.urlImgs.image + '?' + this.timestampImage : '/static/img/profile-placeholder.svg'
    },
    customerImageClass () {
      return {
        'img-responsive': true,
        'center-block': true,
        'img-customer-placeholder': !this.hasImage,
        'img-thumbnail': this.hasImage
      }
    }
  },
  methods: {
    ...mapActions('customers', {
      getUrlImg: 'getUrlImg'
    }),
    editImage () {
      this.$emit('editImage', this.customer)
    }
  }
}
</script>
<style>
  .img-customer-placeholder {
    width: 75%
  }
</style>



// WEBPACK FOOTER //
// src/pages/Customers/CustomerImageCard.vue